export const effect = {
  appear: {
    initial: {},
    animate: {},
    exit: {}
  },
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  },
  slideLeft: {
    initial: { x: '-100%' },
    animate: { x: 0 },
    exit: { x: '-105%' }
  },
  slideRight: {
    initial: { x: '100%' },
    animate: { x: 0 },
    exit: { x: '105%' }
  },
  fadeUp: {
    initial: {
      opacity: 0,
      y: 12
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 12
    }
  }
} as const;
